import React from "react";
import Text from "../Text";
import PaginationIcon from "../../assets/images/pagination-icon.svg";
import styled from "styled-components";
import arrowLeft from "../../assets/images/arrow-left.svg";
import arrowRight from "../../assets/images/arrow-right.svg";

const Pagination = ({
    postsPerPage,
    totalPosts,
    paginate,
    currentPage,
    currentPosts,
    hasNext,
    paginator,
}) => {
    // Use paginator data if available, otherwise calculate from props
    const totalPages =
        paginator?.num_pages || Math.ceil(totalPosts / postsPerPage);
    const totalItems = paginator?.count || totalPosts;
    const hasOtherPages = paginator?.has_other_pages || totalPages > 1;

    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const handlePrevious = (e) => {
        e.preventDefault();
        if (currentPage > 1) {
            paginate(currentPage - 1);
        }
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (currentPage < totalPages) {
            paginate(currentPage + 1);
        }
    };

    // If there's only one page, don't show pagination
    if (totalPages <= 1) {
        return (
            <PaginationInfo>
                Showing {totalItems} record{totalItems !== 1 ? "s" : ""}
            </PaginationInfo>
        );
    }

    return (
        <PaginationWrapper>
            <PaginationButton
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className={currentPage === 1 ? "disabled" : ""}
            >
                <img src={arrowRight} alt="Previous" className="prev-icon" />
                <span>Previous</span>
            </PaginationButton>

            <PageNumbers>
                {pageNumbers.map((number) => (
                    <PageNumber
                        key={number}
                        active={currentPage === number}
                        onClick={(e) => {
                            e.preventDefault();
                            paginate(number);
                        }}
                    >
                        {number}
                    </PageNumber>
                ))}
            </PageNumbers>

            <PaginationButton
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className={currentPage === totalPages ? "disabled" : ""}
            >
                <span>Next</span>
                <img src={arrowRight} alt="Next" className="next-icon" />
            </PaginationButton>
        </PaginationWrapper>
    );
};

export default Pagination;

const PaginationWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0;
`;

const PaginationInfo = styled.div`
    text-align: center;
    color: #505887;
    font-size: 14px;
    padding: 10px 0;
`;

const ResultsInfo = styled(Text)`
    color: ${(props) => props.color || "#8C8888"};
    font-size: ${(props) => props.fontSize || "15px"};
    font-weight: ${(props) => props.fontWeight || "400"};
`;

const PaginationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

const PaginationButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #522e92;
    font-size: 15px;
    font-weight: 500;
    padding: 8px 15px;
    border-radius: 10px;
    border: 1px solid #cdd5df;
    background-color: #fff;
    width: auto;

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .prev-icon {
        transform: rotate(180deg);
    }
`;

const PageNumbers = styled.div`
    display: flex;
    gap: 5px;
    justify-content: center;
    flex: 1;
`;

const PageNumber = styled.button`
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${(props) => (props.active ? "#522e92" : "#e9ecef")};
    background-color: ${(props) => (props.active ? "#522e92" : "transparent")};
    color: ${(props) => (props.active ? "white" : "#505887")};
    cursor: pointer;
    font-size: 14px;

    &:hover {
        border-color: #522e92;
        color: ${(props) => (props.active ? "white" : "#522e92")};
    }
`;
